/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Table_IngestedInputs */

const es_settings_files_table_ingested = /** @type {(inputs: Settings_Files_Table_IngestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingestado`)
};

const en_settings_files_table_ingested = /** @type {(inputs: Settings_Files_Table_IngestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingested`)
};

/**
* | output |
* | --- |
* | "Ingested" |
*
* @param {Settings_Files_Table_IngestedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_table_ingested = /** @type {((inputs?: Settings_Files_Table_IngestedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Table_IngestedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_table_ingested(inputs)
	return en_settings_files_table_ingested(inputs)
});
export { settings_files_table_ingested as "settings.files.table.ingested" }